(() => {
  // One proportional profile for artwork, room scenes, catalogue and cart.
  window.akAluFrameMetrics = (width, height) => {
    const thickness = Math.min(width, height) * .01;
    return {thickness, outside: thickness * .4};
  };
  const placements = new WeakMap();
  const resizeObserver = new ResizeObserver(entries => {
    entries.forEach(({target}) => {
      const args = placements.get(target);
      if (args && args[0].isConnected && target.querySelector(':scope > .ak-css-alu-frame')) {
        window.akDrawAluFrame(target, ...args);
      }
    });
  });
  const mountBounds = {
    portrait:[432,234,1428,1626],
    landscape:[234,432,1626,1428],
    square:[432,431,1429,1428]
  };
  const artTrims = {
    portrait:[.11,.2225,.11,.2195],
    landscape:[.2728,.195,.28,.186],
    square:[.212,.2155,.216,.2135]
  };
  window.akDrawAluFrame = (host, image, format, hasMount, cart = false) => {
    if (!host || !image?.complete || !image.naturalWidth) return;
    const hostRect = host.getBoundingClientRect();
    const rect = image.getBoundingClientRect();
    if (!hostRect.width || !hostRect.height || !rect.width || !rect.height) return;
    let bounds;
    if (hasMount) {
      const [left,top,right,bottom] = mountBounds[format] || mountBounds.portrait;
      bounds = [left/1860,top/1860,right/1860,bottom/1860];
    } else {
      const placement = host.closest('[data-ak-room-placement]');
      const style = placement && getComputedStyle(placement);
      const defaults = artTrims[format] || artTrims.portrait;
      const trims = ['top','right','bottom','left'].map((edge,index) => {
        const value = style && parseFloat(style.getPropertyValue(`--ak-room-art-trim-${edge}`));
        return Number.isFinite(value) ? value / 100 : defaults[index];
      });
      const [top,right,bottom,left] = trims;
      bounds = [left,top,1-right,1-bottom];
      if (cart) image.style.clipPath = `inset(${trims.map(value => `${value*100}%`).join(' ')})`;
    }
    let border = host.querySelector(':scope > .ak-css-alu-frame');
    if (!border) {
      border = document.createElement('span');
      border.className = 'ak-css-alu-frame';
      border.setAttribute('aria-hidden','true');
      host.append(border);
    }
    const hostStyle = getComputedStyle(host);
    const scaleX = (parseFloat(hostStyle.width) || host.clientWidth) / hostRect.width;
    const scaleY = (parseFloat(hostStyle.height) || host.clientHeight) / hostRect.height;
    const {outside, thickness} = window.akAluFrameMetrics(
      rect.width * (bounds[2] - bounds[0]),
      rect.height * (bounds[3] - bounds[1])
    );
    Object.assign(border.style, {
      left:`${(rect.left + rect.width*bounds[0] - hostRect.left - outside)*scaleX}px`,
      top:`${(rect.top + rect.height*bounds[1] - hostRect.top - outside)*scaleY}px`,
      width:`${(rect.width*(bounds[2]-bounds[0]) + outside*2)*scaleX}px`,
      height:`${(rect.height*(bounds[3]-bounds[1]) + outside*2)*scaleY}px`,
      borderWidth:'0px'
    });
    border.style.setProperty('--ak-alu-x', `${thickness * scaleX}px`);
    border.style.setProperty('--ak-alu-y', `${thickness * scaleY}px`);
    if (!placements.has(host)) resizeObserver.observe(host);
    placements.set(host, [image, format, hasMount, cart]);
  };
  let pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => {
      pending = false;
      document.querySelectorAll('[data-ak-cart-frame="black_alu"]').forEach(host => {
        const mount = host.querySelector('.ak-cart-item-mount');
        window.akDrawAluFrame(host, mount || host.querySelector('.ak-cart-item-art'), host.dataset.akCartFormat, !!mount, true);
      });
    });
  }
  new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 &&
      (node.matches('[data-ak-cart-frame="black_alu"]') || node.querySelector('[data-ak-cart-frame="black_alu"]'))))) schedule();
  }).observe(document.body, {childList:true,subtree:true});
  document.addEventListener('load', event => {
    if (event.target.matches?.('[data-ak-cart-frame="black_alu"] img')) schedule();
  }, true);
  window.addEventListener('resize', schedule, {passive:true});
  schedule();
})();
